const priceToUnit = (price: string) => {
  if (price.toString().length < 9) {
    return '만원';
  } else {
    return '억원';
  }
};

const getPricePrefix = (price: string) => {
  return price[0];
};

const getPriceSuffix = (price: number) => {
  const priceToString = Math.floor(price / 100000).toString();

  switch (priceToString.length) {
    // 십만, 십억
    case 1:
    case 5: {
      return '0';
    }

    // 백만, 백억
    case 2:
    case 6: {
      return '00';
    }

    case 3: {
      // 천만
      return '000';
    }

    case 4: {
      // 억
      return '';
    }

    default: {
      return '';
    }
  }
};

const getPriceRange = (value: number) => {
  const unit = Math.floor(value / 10000);

  const valueToString = value.toString();

  if (unit < 10) {
    return '10만원 미만';
  }

  if (unit < 30) {
    return '10만원 이상 ~ 30만원 미만';
  }

  if (unit < 50) {
    return '30만원 이상 ~ 50만원 미만';
  }

  if (unit < 100) {
    return '50만원 이상 ~ 100만원 미만';
  }

  if (unit < 300) {
    return '100만원 이상 ~ 300만원 미만';
  }

  if (unit < 500) {
    return '300만원 이상 ~ 500만원 미만';
  }

  if (unit < 1000) {
    return '500만원 이상 ~ 1000만원 미만';
  }

  const prefix = getPricePrefix(valueToString);

  const suffix = getPriceSuffix(value);

  return `${prefix + suffix + priceToUnit(valueToString)} 이상 ~ ${
    Number(prefix) + 1 + (suffix + priceToUnit(valueToString))
  } 미만`;
};

export default getPriceRange;
